<template>
    <div class="thanks__content">
        <div class="wrapper">
            <div class="thanks__icon">
                <div class="thanks__circle">
                    <div class="thanks__check"></div>
                </div>
            </div>
            <div class="thanks__desc">
                <p>
                    <b>Dziękujemy za zgłoszenie przypadku!</b>
                </p>
                <p>Twoja wiadomość zostanie przekazana do ośrodka referencyjnego.</p>
                <p>Aby zobaczyć zgłoszone przypadki wejdź w zakładkę Zgłoszenia.</p>
            </div>
            <div class="thanks__desc">
                <b>Numer zgłoszenia to</b>
                <code>{{ medicalCaseShortId }}</code>
            </div>
            <div class="form__row form__row--center">
                <router-link to="/" class="btn">Dziękujemy</router-link>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
    name: "Thanks",
    data() {
        return {
            medicalCaseShortId: "",
        };
    },
    props: {
        medicalCaseId: {
            type: String,
            required: true,
        },
    },
    computed: mapGetters({
        securedHeaders: "getSecuredRequestHeader",
    }),
    methods: {
        getMedicalCase(id) {
            axios
                .get(`${process.env.VUE_APP_API_URL}/medical-case/${id}`, {
                    headers: this.securedHeaders,
                })
                .then((response) => {
                    this.medicalCaseShortId = response.data.shortId;
                });
        }
    },
    mounted() {
        if (this.medicalCaseId !== "") this.getMedicalCase(this.medicalCaseId);
    }
};
</script>

<style lang="scss">
.thanks {
    &__icon {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
    }

    &__circle {
        width: 125px;
        height: 125px;
        border-radius: 50%;
        background: #4CAB6B;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &__check {
        animation: checkAnimation 1s linear forwards;
        transform: rotate(-405deg);
        border: 5px solid transparent;
    }

    &__content {
        text-align: center;
        margin: 45px 0;
    }

    &__desc {
        margin: 30px 0;

        p {
            margin: 0;
        }
    }
}

@keyframes checkAnimation {
    0% {
        width: 100px;
        height: 100px;
        border-left: 5px solid white;
        border-radius: 50%;
        transform: rotate(0deg);
        margin-top: 0;
    }
    80% {
        width: 100px;
        height: 100px;
        border-left: 5px solid white;
        border-radius: 50%;
        transform: rotate(-360deg);
        border-bottom: 5px solid transparent;
        margin-top: 0;
    }
    100% {
        height: 30px;
        width: 60px;
        border-radius: 6px;
        border-bottom: 5px solid white;
        border-left: 5px solid white;
        transform: rotate(-405px);
        margin-top: -20px;
    }
}
</style>
